import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";
import moment from "moment";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  onFilterApply,
}) {
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  // const [hubFilter, setHubFilter] = useState("");
  const [hubFilter, setHubFilter] = useState("");

  // Function to validate if a date is valid
  const isValidDate = (date) => {
    return moment(date, "YYYY-MM-DD", true).isValid();
  };

  const fetchData = async () => {
    if (!isValidDate(fromDate) || !isValidDate(toDate)) {
      return;
    }
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      // Format the dates properly before sending them to the API
      const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
      const formattedToDate = moment(toDate).format("YYYY-MM-DD");

      const url = `${process.env.REACT_APP_BASE_URL}/api/v1/orders/user-summary/consolidation?dateFrom=${fromDate}&dateTo=${toDate}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const { userSummary } = response.data;
      if (Array.isArray(userSummary?.userSummary)) {
        const userData = userSummary.userSummary.map((user) => ({
          name: user.name,
          trips: user.trips,
          totalKm: user.totalKm,
          totalAmount: user.totalAmount,
          totalOrders: user.totalOrders,
          tripSummary: user.tripSummary,
        }));

        setFilteredData(userData);
      } else {
        console.error("Unexpected data format from ", userSummary?.userSummary);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const debounceFetchData = useCallback(
    debounce(() => {
      fetchData();
    }, 500), // 500ms debounce delay
    [fromDate, toDate]
  );
  useEffect(() => {
    let filtered = apidata || [];
    // Filter by search input (numberplate)
    if (dataFilter) {
      filtered = filtered.filter((item) => {
        if (searchBy === "name") {
          return (
            item.name &&
            item.name.toLowerCase().includes(dataFilter.toLowerCase())
          );
        }
        return false;
      });
    }

    // if (hubFilter) {
    //   filtered = filtered.filter((item) => {
    //     if (
    //       item.tripSummary &&
    //       typeof item.tripSummary === "object" &&
    //       Object.values(item.tripSummary).some(
    //         (summary) =>
    //           summary.hub &&
    //           summary.hub.toLowerCase().includes(hubFilter.toLowerCase())
    //       )
    //     ) {
    //       return true;
    //     }
    //     return false;
    //   });
    // }

    if (hubFilter.length > 0) {
      filtered = filtered.filter((item) => {
        return Object.values(item.tripSummary || {}).some((summary) =>
          hubFilter.includes(summary.hub)
        );
      });
    }

    setFilteredData(filtered); // Update filtered data state
  }, [dataFilter, apidata, searchBy, hubFilter]);

  // const applyFilters = () => {
  //   if (isValidDate(fromDate) && isValidDate(toDate)) {
  //     const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
  //     const formattedToDate = moment(toDate).format("YYYY-MM-DD");
  //     onFilterApply(formattedFromDate, formattedToDate, hubFilter);
  //     setShowFilterModal(false);
  //   } else {
  //     console.error("Invalid dates provided for applying filters.");
  //   }
  // };

  const applyFilters = () => {
    let formattedFromDate = "";
    let formattedToDate = "";

    if (isValidDate(fromDate)) {
      formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
    }

    if (isValidDate(toDate)) {
      formattedToDate = moment(toDate).format("YYYY-MM-DD");
    }

    onFilterApply(formattedFromDate, formattedToDate, hubFilter);

    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setFromDate(""); // Clear from date
    setToDate(""); // Clear to date
    setDataFilter(""); // Clear search filter
    setFilteredData(apidata); // Reset to the original unfiltered data
    onFilterApply("", ""); // Notify parent to reset filters (optional)
    // setHubFilter("");
    setHubFilter([]);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        <div className="col-md-9 mb-2 d-flex align-items-center">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
      />
    </div>
  );
}

// Utility function for debouncing
function debounce(func, delay) {
  let timeout;
  const debouncedFunc = (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
  debouncedFunc.cancel = () => clearTimeout(timeout);
  return debouncedFunc;
}
